import {
  Calculator, HardHat, GanttChartSquare,
  Users, ShieldCheck, Zap, Handshake,
  Award, Folder, Calendar, Heart, Layers,
  ClipboardCheck,
  ArrowUpRight, ArrowRight, MapPin, Phone, Mail,
} from "lucide-react";

export const ICON_MAP = {
  calculator: Calculator,
  hardhat: HardHat,
  gantt: GanttChartSquare,
  amo: ClipboardCheck,
  users: Users,
  shield: ShieldCheck,
  zap: Zap,
  handshake: Handshake,
  award: Award,
  folder: Folder,
  calendar: Calendar,
  heart: Heart,
  layers: Layers,
  arrowUpRight: ArrowUpRight,
  arrowRight: ArrowRight,
  mapPin: MapPin,
  phone: Phone,
  mail: Mail,
};

export const ICON_OPTIONS = [
  { key: "calculator", label: "Calculatrice (Économie)" },
  { key: "amo", label: "Presse-papier validé (AMO)" },
  { key: "hardhat", label: "Casque (MOEx)" },
  { key: "gantt", label: "Diagramme (OPC)" },
  { key: "users", label: "Personnes" },
  { key: "shield", label: "Bouclier" },
  { key: "zap", label: "Éclair" },
  { key: "handshake", label: "Poignée de main" },
  { key: "award", label: "Récompense" },
  { key: "folder", label: "Dossier" },
  { key: "calendar", label: "Calendrier" },
  { key: "heart", label: "Cœur" },
  { key: "layers", label: "Couches" },
];

export const Icon = ({ name, ...props }) => {
  const C = ICON_MAP[name] || Calculator;
  return <C {...props} />;
};
